module.exports = __webpack_public_path__ + "static/media/man3.53511438.jpg";